module.exports = {
          srcSet: __webpack_public_path__ + "87e19fac40835f54822c3b24b9ab5a23-801.png"+" 801w",
          images:[ {path: __webpack_public_path__ + "87e19fac40835f54822c3b24b9ab5a23-801.png",width: 801,height: 566}],
          src: __webpack_public_path__ + "87e19fac40835f54822c3b24b9ab5a23-801.png",
          toString:function(){return __webpack_public_path__ + "87e19fac40835f54822c3b24b9ab5a23-801.png"},
          
          width: 801,
          height: 566
        }